module.exports = __webpack_public_path__ + "599d9fe58775aeb89c10f2d0187eb91f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/30_ICON_10_A.png
// module id = 130
// module chunks = 0